import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
    title: 'Assets',
    attributeName: 'mainhubCustomizationAssets',
    fields: [
        {
            attributeName: 'splashScreen',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Splash screen(Transparent)',
            helpText: 'Each Black Label app has a personalised Splash Screen based on its logo or branding. It will appear on the app with an animation effect. This asset must be a .png static image',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: 'logo',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Logo(Transparent)',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: 'environment',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Environment',
            helpText: 'The Black label app exists inside an environment. It will be created by  a estereoscopic photography that can be chosen by the client.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: "sep1",
            type: FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'locationMapIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Location Map Icon',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: 'locationMapBackgroundIcon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Location Map Background Icon',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: "sep2",
            type: FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'location180Icon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Location 180 Icon',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: 'location180IconHover',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Location 180 Icon - Hover',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: 'location180IconSelected',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Location 180 Icon - Selected',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: "sep3",
            type: FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'location360Icon',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Location 360 Icon',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: 'location360IconHover',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Location 360 Icon - Hover',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
        {
            attributeName: 'location360IconSelected',
            type: FormInputTypes.DOWNLOADABLE,
            label: 'Location 360 Icon - Selected',
            helpText: 'The asset can have a background fill, but it will appear with this background in the home scene. Transparency is recommended. The logo should be perfectly visible and separated from the background. If necessary, the user can upload the logo’s negative or positive version.',
            hasSelect: false,
            fileType: ['.png'],
        },
    ]
}